'use strict';

partnershipOverview.$inject = ["Paging"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.partnershipOverview = partnershipOverview;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function partnershipOverview(Paging) {
    var clazz = function PartnershipOverview() {
        var defaults = {
            partnerships: [],
            isLoadingInitial: false,
            isLoading: false,
            errorOccurred: false,
            paging: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (pageSize) {
        var partnershipOverview = new clazz();
        partnershipOverview.partnerships = [];
        partnershipOverview.paging = Paging.create({ totalItems: 0, itemsPerPage: pageSize ? pageSize : 12, page: 1, pageCount: 1, pageNumbers: [] });
        return partnershipOverview;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/partnershipOverviewModel.js
// module id = 772
// module chunks = 0